import { Match } from 'interfaces/match';
import Team from 'interfaces/team';
import { TeamOption } from '../../../enums/teamOption';

export default function getTeamFromTeamOption(teamOption: TeamOption | null, match: Match): Team | null {
  if (!teamOption) return null;
  return teamOption === TeamOption.HOME ? match.homeTeam : match.awayTeam;
}
